var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["controls/display-faceout-fits.j2"] = require( "controls/display-faceout-fits.j2" );
dependencies["controls/display-faceout-sizes.j2"] = require( "controls/display-faceout-sizes.j2" );
dependencies["macros/product-swatches.j2"] = require( "macros/product-swatches.j2" );
dependencies["controls/back-in-stock-section.j2"] = require( "controls/back-in-stock-section.j2" );
dependencies["gift-card/product-gift-card-message.j2"] = require( "gift-card/product-gift-card-message.j2" );
dependencies["product-quantity-container.j2"] = require( "product-quantity-container.j2" );
dependencies["controls/quickship-message.j2"] = require( "controls/quickship-message.j2" );
dependencies["gift-card/product-gift-card.j2"] = require( "gift-card/product-gift-card.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/controls/product-controls-faceout.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("controls/display-faceout-fits.j2", false, "product/templates/controls/product-controls-faceout.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFaceoutFits")) {
var t_4 = t_1.displayFaceoutFits;
} else {
cb(new Error("cannot import 'displayFaceoutFits'")); return;
}
context.setVariable("displayFaceoutFits", t_4);
env.getTemplate("controls/display-faceout-sizes.j2", false, "product/templates/controls/product-controls-faceout.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("displayFaceoutSizes")) {
var t_8 = t_5.displayFaceoutSizes;
} else {
cb(new Error("cannot import 'displayFaceoutSizes'")); return;
}
context.setVariable("displayFaceoutSizes", t_8);
output += "<div class=\"c-product-controls u-clearfix dom-product-controls\" data-qa-product-controls>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity")) {
var t_9;
t_9 = !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut")) && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"selectedItem")),"purchased_quantity") == 0;
frame.set("controlsActive", t_9, true);
if(frame.topLevel) {
context.setVariable("controlsActive", t_9);
}
if(frame.topLevel) {
context.addExport("controlsActive", t_9);
}
;
}
else {
var t_10;
t_10 = !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut"));
frame.set("controlsActive", t_10, true);
if(frame.topLevel) {
context.setVariable("controlsActive", t_10);
}
if(frame.topLevel) {
context.addExport("controlsActive", t_10);
}
;
}
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard")) {
output += "\n\n        <div class=\"o-row c-product-colors js-product-colors\" data-qa-colors>\n\n            <div class=\"o-column o-extra-small--12 o-extra-large--10\">\n\n                <fieldset>\n\n                    <legend class=\"c-product-colors__legend c-form__label\" data-qa-selectedcolor=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"colorName"), env.opts.autoescape);
output += "\">\n\n                        ";
output += runtime.suppressValue((lineno = 21, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.controlsData.colorLabel"])), env.opts.autoescape);
output += ":\n\n                        <span class=\"c-product-colors__name u-global-p\">\n\n                            ";
output += runtime.suppressValue((lineno = 25, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productControls.colorName"])), env.opts.autoescape);
output += "\n\n                        </span>\n\n                    </legend>\n\n                    ";
env.getTemplate("macros/product-swatches.j2", false, "product/templates/controls/product-controls-faceout.j2", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
context.setVariable("swatches", t_11);
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 33, colno = 45, runtime.callWrap(runtime.memberLookup((t_11),"displaySwatches"), "swatches[\"displaySwatches\"]", context, [runtime.contextOrFrameLookup(context, frame, "product"),runtime.makeKeywordArgs({"source": "product","enabled": runtime.contextOrFrameLookup(context, frame, "controlsActive")})])), env.opts.autoescape);
output += "\n\n                </fieldset>\n\n            </div>\n\n        </div>";
})});
}
output += "\n\n    ";
var t_14;
t_14 = (lineno = 43, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.browseDisplayOptions.showRequestSwatch",false]));
frame.set("requestSwatchIsEnabled", t_14, true);
if(frame.topLevel) {
context.setVariable("requestSwatchIsEnabled", t_14);
}
if(frame.topLevel) {
context.addExport("requestSwatchIsEnabled", t_14);
}
output += "\n\n    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideRequestSwatch") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language") != "fr-CA" && runtime.contextOrFrameLookup(context, frame, "requestSwatchIsEnabled")) {
output += "<div class=\"o-row c-product-request-swatch-link\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                 <p class=\"u-global-p\">\n\n                    <a class=\"c-request-swatch-cta js-request-swatch-cta\" href=\"#\" data-qa-request-swatch-link>";
output += runtime.suppressValue((lineno = 56, colno = 113, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-request-swatch",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</a>\n\n                </p>\n\n            </div>\n\n        </div>";
;
}
output += "<div class=\"c-product-sizes js-product-sizes u-clearfix\" data-qa-sizes>\n\n        ";
output += "\n        ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeTypeGroupId");
frame.set("selectedSizeTypeGroupId", t_15, true);
if(frame.topLevel) {
context.setVariable("selectedSizeTypeGroupId", t_15);
}
if(frame.topLevel) {
context.addExport("selectedSizeTypeGroupId", t_15);
}
output += "\n        ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeTypeCode");
frame.set("selectedSizeTypeCode", t_16, true);
if(frame.topLevel) {
context.setVariable("selectedSizeTypeCode", t_16);
}
if(frame.topLevel) {
context.addExport("selectedSizeTypeCode", t_16);
}
output += "\n        ";
var t_17;
t_17 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeId");
frame.set("selectedSizeId", t_17, true);
if(frame.topLevel) {
context.setVariable("selectedSizeId", t_17);
}
if(frame.topLevel) {
context.addExport("selectedSizeId", t_17);
}
output += "\n        ";
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"colorCode");
frame.set("selectedColorCode", t_18, true);
if(frame.topLevel) {
context.setVariable("selectedColorCode", t_18);
}
if(frame.topLevel) {
context.addExport("selectedColorCode", t_18);
}
output += "\n        ";
var t_19;
t_19 = (lineno = 73, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.controlsData.colorData." + "" + runtime.contextOrFrameLookup(context, frame, "selectedColorCode") + "" + ".fitDisplayOrder",[]]));
frame.set("fitDisplayOrder", t_19, true);
if(frame.topLevel) {
context.setVariable("fitDisplayOrder", t_19);
}
if(frame.topLevel) {
context.addExport("fitDisplayOrder", t_19);
}
output += "\n        ";
var t_20;
t_20 = (lineno = 74, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.controlsData.colorData." + "" + runtime.contextOrFrameLookup(context, frame, "selectedColorCode") + "" + ".fitData",{}]));
frame.set("fitData", t_20, true);
if(frame.topLevel) {
context.setVariable("fitData", t_20);
}
if(frame.topLevel) {
context.addExport("fitData", t_20);
}
output += "\n\n        ";
output += runtime.suppressValue((lineno = 76, colno = 27, runtime.callWrap(t_4, "displayFaceoutFits", context, [runtime.contextOrFrameLookup(context, frame, "fitDisplayOrder"),runtime.contextOrFrameLookup(context, frame, "fitData"),runtime.contextOrFrameLookup(context, frame, "selectedSizeTypeGroupId"),runtime.contextOrFrameLookup(context, frame, "selectedSizeTypeCode"),runtime.contextOrFrameLookup(context, frame, "controlsActive")])), env.opts.autoescape);
output += "\n\n        <div class=\"o-row\">\n\n            ";
output += "\n            ";
var t_21;
t_21 = !(env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "forFamilyProduct"),runtime.contextOrFrameLookup(context, frame, "False"))) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"sizeGuide");
frame.set("shouldShowSizeChart", t_21, true);
if(frame.topLevel) {
context.setVariable("shouldShowSizeChart", t_21);
}
if(frame.topLevel) {
context.addExport("shouldShowSizeChart", t_21);
}
output += "\n            ";
var t_22;
t_22 = (lineno = 82, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["fitData." + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeTypeCode") + "" + ".sizeDisplayOrder",[]]));
frame.set("sizeDisplayOrder", t_22, true);
if(frame.topLevel) {
context.setVariable("sizeDisplayOrder", t_22);
}
if(frame.topLevel) {
context.addExport("sizeDisplayOrder", t_22);
}
output += "\n            ";
var t_23;
t_23 = (lineno = 83, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["fitData." + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeTypeCode") + "" + ".sizeData",{}]));
frame.set("sizeData", t_23, true);
if(frame.topLevel) {
context.setVariable("sizeData", t_23);
}
if(frame.topLevel) {
context.addExport("sizeData", t_23);
}
output += "\n\n            ";
output += runtime.suppressValue((lineno = 85, colno = 32, runtime.callWrap(t_8, "displayFaceoutSizes", context, [runtime.contextOrFrameLookup(context, frame, "sizeDisplayOrder"),runtime.contextOrFrameLookup(context, frame, "sizeData"),runtime.contextOrFrameLookup(context, frame, "selectedSizeTypeCode"),runtime.contextOrFrameLookup(context, frame, "selectedSizeId"),runtime.makeKeywordArgs({"showSizeChart": runtime.contextOrFrameLookup(context, frame, "shouldShowSizeChart"),"enabled": runtime.contextOrFrameLookup(context, frame, "controlsActive")})])), env.opts.autoescape);
output += "\n\n        </div>\n\n    </div>\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"backInStockEnabled") && !(lineno = 91, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.product.isSoldOut"]))) {
output += "\n        ";
env.getTemplate("controls/back-in-stock-section.j2", false, "product/templates/controls/product-controls-faceout.j2", null, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_24.render(context.getVariables(), frame, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
output += t_25
output += "\n    ";
})});
}
output += "\n\n    ";
var t_28;
t_28 = (lineno = 95, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.pdpOptions.physical_gift_card_has_message"]));
frame.set("physicalGiftCardHasMessage", t_28, true);
if(frame.topLevel) {
context.setVariable("physicalGiftCardHasMessage", t_28);
}
if(frame.topLevel) {
context.addExport("physicalGiftCardHasMessage", t_28);
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isGiftCard") && runtime.contextOrFrameLookup(context, frame, "physicalGiftCardHasMessage")) {
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("gift-card/product-gift-card-message.j2", false, "product/templates/controls/product-controls-faceout.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n            </div>\n\n        </div>\n\n    ";
})});
}
output += "\n\n    <div class=\"o-row\">\n        ";
env.getTemplate("product-quantity-container.j2", false, "product/templates/controls/product-controls-faceout.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n    </div>\n\n    ";
if((lineno = 115, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.configs.quickShipEnabled",false]))) {
env.getTemplate("controls/quickship-message.j2", false, "product/templates/controls/product-controls-faceout.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
})});
}
output += "\n\n    ";
output += "\n    ";
env.getTemplate("gift-card/product-gift-card.j2", false, "product/templates/controls/product-controls-faceout.j2", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/controls/product-controls-faceout.j2"] , dependencies)